import { translationTextLanguageHintsVar } from "graphql/cache";

import { hashText } from "../translation-cache";

const getLanguageHintKey = ({
        namespace,
        context,
        text
    }) => `${ namespace || "input" }:${ context || "" }:${ hashText(text || "") }`;

export const getTextLanguageHint = ({
        namespace,
        context,
        text
    }) => {
    const key = getLanguageHintKey({ namespace, context, text });

    return translationTextLanguageHintsVar()[key] || null;
};

export const setTextLanguageHint = ({
        namespace,
        context,
        text,
        language
    }) => {
    if (!text || !language) return;

    const key = getLanguageHintKey({ namespace, context, text });

    translationTextLanguageHintsVar({
        ...translationTextLanguageHintsVar(),
        [key]: language
    });
};
